<template>
  <div class="recharge-order-detail" :class="{'isiOSX':isiOSX}">
    <!-- <div class="header-fill"></div> -->
    <nav-bar titleText="订单详情" fontColor="#333333" @goBack="goBack" bgc="#ffffff" :isFixed="true"></nav-bar>
    <div class="status-box">
      <div class="status">{{ statusName }}</div>
      <div class="countdown" v-if="this.status == 1">
        <span>剩余</span>
        <van-count-down :time="oderDetail.order_close_time" format="HH小时mm分ss秒" @finish="finished" />
        <span>自动关闭</span>
      </div>
      <div class="countdown" v-if="this.status != 1">
        <span>{{ statusDesc }}</span>
      </div>
    </div>
    <div class="charge-content-box">
      <div class="title">
        <div>
          <span class="icon">充</span>
          <span class="recharge-center">充值中心</span>
        </div>
      </div>
      <div class="platform">{{ oderDetail.title}}</div>
      <div class="light-font" v-show="oderDetail.charge_id !== 11 && oderDetail.charge_id !== 9">充值账号：{{ oderDetail.charge_account }}</div>
      <div class="light-font">产品名称： {{ oderDetail.product_name }}</div>
      <div class="split-line"></div>
      <div class="recharge-amount">
        <div class="left">充值金额:</div>
        <div class="right">¥{{ oderDetail.original_price? parseFloat(oderDetail.original_price).toFixed(2) : "" }}</div>
      </div>
      <div class="payment">
        <div class="left">实付款:</div>
        <div class="right active">¥{{ oderDetail.pay_money? parseFloat(oderDetail.pay_money).toFixed(2) : "" }}</div>
      </div>
    </div>

    <div class="charge-detail-box">
      <div class="title">订单详情</div>
      <div class="detail">
        <div style="color: #F9591B">
          <span class="c-left">赠积分：</span>
          <span>{{ oderDetail.giving_credits?parseFloat(oderDetail.giving_credits).toFixed(4) : "" }}</span>
        </div>
        <div v-show="oderDetail.deduct_balance || oderDetail.deduct_balance == 0">
          <span class="c-left">个人余额抵扣</span>
          <span>¥{{ (oderDetail.deduct_balance || oderDetail.deduct_balance == 0) ? parseFloat(oderDetail.deduct_balance).toFixed(2) : "" }}</span>
        </div>
        <div>
          <span class="c-left">订单编号：</span>
          <span>{{ oderDetail.ordersn }}</span>
        </div>
        <div v-if="charge_type == 1">
          <span class="c-left">归属地：</span>
          <span>{{ oderDetail.city }}</span>
        </div>
        <div v-if="charge_type == 1">
          <span class="c-left">服务商：</span>
          <span>{{oderDetail.provider_name}}</span>
        </div>
        <div>
          <span class="c-left">下单时间：</span>
          <span>{{ oderDetail.created_at }}</span>
        </div>
        <div v-if="status == 4">
          <span class="c-left">充值时间：</span>
          <span>{{ oderDetail.finish_time }}</span>
        </div>
        <!-- 11 百度网盘 -->
        <div v-if="status == 4 && oderDetail.charge_id == 11">
          <span class="c-left">兑换网址：</span>
          <a :href="oderDetail.bd_exchange_url" style="color: #F9591B">{{ oderDetail.bd_exchange_url}}</a>
        </div>
        <!-- 9 网易云音乐 -->
        <div class="exchange-methods" v-if="status == 4 && oderDetail.charge_id == 9">
          <div class="c-left">兑换方式：</div>
          <div class="exchange-right">
            <div>
              <span style="color: #F9591B">{{ iosExchangeExplain.slice(0,2) }}</span>{{ iosExchangeExplain.slice(2) }}
            </div>
            <div>
              <span style="color: #F9591B">{{ androidExchangeExplain.slice(0,2) }}</span>{{ androidExchangeExplain.slice(2) }}
            </div>
          </div>
        </div>
        <div class="code-box" v-if="status == 4 && platformWithCard.includes(oderDetail.charge_id)">
          <span class="c-left">兑换码：</span>
          <span ref="copytxt">{{ oderDetail.card_password }}</span>
          <!-- <span ref="copytxt">1232132123123123h1jk2h3</span> -->
          <div class="copy">
            <span @click="copyCode">复制</span>
          </div>
        </div>
        <div v-if="status == 5">
          <span class="c-left">关闭时间：</span>
          <span>{{ oderDetail.close_time }}</span>
        </div>
      </div>
    </div>

    <div class="btn">
      <div class="btn-status" v-if="status === 1">
        <button class="btn-primary" @click="rechargePay">立即付款</button>
        <button class="btn-default" @click="chat">联系客服</button>
        <button class="btn-default" @click="cancelOrder">取消订单</button>
      </div>
      <!-- <div class="btn-status" v-if="status === 2"> -->
      <div class="btn-status" v-if="[2,3].includes(status)">
        <button class="btn-default"  @click="chat">联系客服</button>
      </div>
      <!-- <div class="btn-status" v-if="[3,4,5].includes(status)"> -->
      <div class="btn-status" v-if="[4,5].includes(status)">
        <button class="btn-default"  @click="chat">联系客服</button>
        <button class="btn-default"  @click="delOrder">删除订单</button>
      </div>
    </div>

    <!-- <bottom-bar bgc="#ffffff"></bottom-bar> -->
    <van-dialog
      v-model="showDialog"
      :message="dialogMessage"
      :confirm-button-text="confirmText"
      confirm-button-color="#F9591B"
      :cancel-button-text="cancelText"
      cancel-button-color="#999999"
      @confirm="confirmEvent"
      show-cancel-button
    >
    </van-dialog>

  </div>
</template>

<script>
import navBar from "./components/navBar"
import bottomBar from "./components/bottomBar"
import Bus from "../../providers/eventBus"
export default {
  data() {
    return {
      isiOSX: false,
      // time: 24 * 60 * 60 * 1000,
      time: 0,
      status: -1,
      statusName: '',
      dialogMessage: '',
      oderDetail: {},
      iosExchangeExplain: '',
      androidExchangeExplain: '',
      confirmText: '',
      cancelText: '',
      confirmEvent: {},
      showDialog: false,
      platformClassify: {},
      charge_type: this.$route.query.charge_type,
      // 9->网易云音乐  11->百度网盘
      platformWithCard: [9, 11],
      orderStatus: 0,
      statusDesc:''
    };
  },
  components: {
    navBar,
    bottomBar,
  },
  created() {
    this.isiOSX = this.isIphoneX();
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token)
    }
    this.orderStatus = this.$route.query.orderStatus
    this.getOrderDetail()
  },
  mounted() {},
  methods: {
    // 跳转原生支付
    rechargePay(){
      let param = {
        actual_amount: parseFloat(this.oderDetail.pay_money).toFixed(2),  
        deduct_coin: this.oderDetail.deduct_coin,    
        deduct_credits: this.oderDetail.deduct_credits,
        order_amount: parseFloat(this.oderDetail.original_price).toFixed(2),
        ordersn: this.oderDetail.ordersn,
      }
      this.params(JSON.stringify(param),JSON.stringify(param),"rechargePay")
    },
    // 联系客服 
    chat(){
      this.params('','','chat')
    },
    // 倒计时结束
    finished(){
      this.getOrderDetail()
    },
    // 取消订单
    cancelOrder(){
      this.dialogMessage = '您是否要取消该订单？'
      this.confirmText = '确认取消'
      this.cancelText = '返回'
      this.confirmEvent = () => {
        this.$api.post('/order/member/order/cancel',{
          ordersn: this.oderDetail.ordersn
        })
        .then(res => {
          this.getOrderDetail()
          this.showDialog = false
          // this.status = 4
        })
        .catch(err => {
          this.getOrderDetail()
          this.showDialog = false
        })
      }
      this.showDialog = true
    },
    // 删除订单
    delOrder(){
      this.dialogMessage = '您是否要删除该订单？'
      this.confirmText = '确认删除'
      this.cancelText = '取消'
      this.confirmEvent = () => {
        this.$api.post('/order/member/order/delete',{
          ordersn: this.oderDetail.ordersn
        })
        .then(res => {
          this.status = 4
          this.showDialog = false
          // 删除订单成功后重新刷新。
          this.getOrderDetail()
          this.$router.go(-1)
        })
        .catch(err => {
          this.showDialog = false
        })
      }
      this.showDialog = true
    },
    goBack(){
      this.$router.go(-1)
    },
    getOrderDetail(){
      this.$api.post('/thirdrecharge/member/order/info', {order_id: this.$route.query.order_id})
      .then(data => {
        this.oderDetail = data
        this.status = data.status
        const _wy_exchange_explain = data.wy_exchange_explain.split('\n')
        // const _wy_exchange_explain = '苹果手机兑换方法：网易云音乐app-账号- 我的会员-右上角人型按钮-兑换中心\n苹果手机兑换方法：网易云音乐app-账号- 我的会员-右上角人型按钮-兑换中心'.split('\n')
        this.iosExchangeExplain = _wy_exchange_explain[0]
        this.androidExchangeExplain = _wy_exchange_explain.length > 1 ? _wy_exchange_explain[1] : ''
        switch(this.status) {
          case 1:
            this.statusName = '待付款'
            this.statusDesc = ""
            break
          case 2:
            this.statusName = '正充值'
            this.statusDesc = "正在充值中，请耐心等待"
            break
          case 3:
            this.statusName = '正充值'
            this.statusDesc = "充值失败，请联系客服重新充值"
            break
          case 4:
            this.statusName = '已完成'
            this.statusDesc = "感谢你使用销巴生活～"
            break
          case 5:
            this.statusName = '已关闭'
            this.statusDesc = "我们将继续努力，期待你再次使用销巴生活～"
            break
          default:
        }
      })
    },
    copyCode(){
        const rechage_range = document.createRange();
        rechage_range.selectNode(this.$refs.copytxt);
        const rechage_selection = window.getSelection();
        if(rechage_selection.rangeCount > 0) rechage_selection.removeAllRanges();
        rechage_selection.addRange(rechage_range);
        document.execCommand('Copy');
        this.$toast('复制成功')
        rechage_selection.removeAllRanges()
    },
  },
  beforeDestroy() {
    Bus.$emit('busRechargeDetail', {
      charge_from: 'detail',
      orderStatus: this.orderStatus,
    })
  },
};
</script>

<style lang="less">
.recharge-order-detail {
  padding-top: 88px;
  padding-bottom: 79px;
  position: relative;
  height: calc(100% - 167px);
  background-color: #f5f6f7;
  overflow-y: auto;
  // .header-fill {
  //   position: fixed;
  //   top: 0;
  //   height: 0;
  //   padding-top: 44px;
  //   width: 100%;
  //   background-color: #ffffff;
  // } 
  .status-box {
    background: linear-gradient(
      270deg,
      rgba(244, 26, 60, 1) 0%,
      rgba(252, 116, 12, 1) 100%
    );
    padding: 27px 0 31px 30px;
    .status {
      height: 32px;
      line-height: 32px;
      font-size: 20px;
      font-weight: bold!important;
      color: #ffffff;
    }
    .countdown {
      margin-top: 6px;
      display: flex;
      height: 24px;
      line-height: 24px;
      font-size: 15px;
      color: #ffffff;
    }
    .van-count-down {
      color: #ffffff;
      font-size: 15px;
      height: 24px;
      line-height: 24px;
    }
  }
  .charge-content-box {
    // height: 203px;
    background-color: #ffffff;
    padding: 12px 0 12px 12px;
    margin: 12px 0;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      .icon {
        display: inline-block;
        border-radius: 50%;
        height: 20px;
        width: 20px;
        text-align: center;
        background: linear-gradient(
          270deg,
          rgba(244, 26, 60, 1) 0%,
          rgba(252, 116, 12, 1) 100%
        );
        font-size: 13px;
        color: #ffffff;
        line-height: 21px;
      }
      .recharge-center {
        height: 24px;
        line-height: 24px;
        margin-left: 8px;
        font-size: 15px;
        color: #333333;
      }
    }
    .platform {
      height: 26px;
      line-height: 26px;
      color: #333333;
      margin-bottom: 5px;
      font-size: 16px;
      font-weight: bold!important;
    }
    .light-font {
      height: 21px;
      line-height: 21px;
      color: #999999;
      margin-bottom: 1px;
      font-size: 13px;
    }
    .split-line {
      width: 351px;
      height: 0.5px;
      background-color: #eeeeee;
      margin: 12px 0 13px;
    }
    .recharge-amount {
      display: flex;
      justify-content: space-between;
      padding-right: 12px;
      margin-bottom: 3px;
      height: 21px;
      font-size: 13px;
      color: rgba(153, 153, 153, 1);
      line-height: 21px;
    }
    .payment {
      display: flex;
      justify-content: space-between;
      padding-right: 12px;
      height: 24px;
      font-size: 15px;
      color: #333333;
      line-height: 24px;
    }
  }
  .charge-detail-box {
    // height: 177px;
    background-color: #ffffff;
    padding: 12px 0 9px 12px;
    // margin: 12px 0 107px;
    .title {
      height: 26px;
      font-size: 16px;
      color: #333333;
      line-height: 26px;
    }
    .detail {
      margin-top: 8px;
      & > div {
        // height: 21px;
        font-size: 13px;
        color: #999999;
        line-height: 21px;
        margin-bottom: 3px;
        padding-right: 12px;
        .c-left {
          display: inline-block;
          width: 95px;
        }
        a {
          font-size: 13px;
        }
      }
      .exchange-methods {
        display: flex;
        justify-content: space-between;
        // align-items: center;
        // calc(100% - 88px);
        .exchange-right {
          max-width: calc(100% - 95px);;
        }
      }
      .code-box {
        position: relative;
        .copy {
          position: absolute;
          right: 12px;
          top: 1px;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          font-size:13px;
          color:rgba(249,89,27,1);
          width:35px;
          height:18px;
          border-radius:9px;
          border:1px solid rgba(249,89,27,1);
          box-sizing: border-box;
        }
      }
      .van-count-down {
        display: inline-block;
      }
    }
  }
   .btn {
     position: fixed;
     bottom: 0;
     width: 100%;
    //  background-color: #f5f6f7;
     background-color: #ffffff;
    .btn-status {
      display: flex;
      align-items: center;
      flex-direction: row-reverse;
      // background-color: #ffffff;
      padding: 9px 12px 30px 0;
      height: 40px;
      line-height: 40px;
      button {
      // 去除button默认样式
      border: none;
      outline: none;
      -webkit-appearance: none;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      }
      .btn-primary {
        margin-left: 12px;
        padding: 0 20px;
        font-size:15px;
        color: #ffffff;
        background-color: #F9591B;
        box-sizing: border-box;
        border-radius:20px;
        border: 1px solid #F9591B;
      }
      .btn-default {
        margin-left: 12px;
        padding: 0 20px;
        font-size:15px;
        color: #999999;
        background-color: #ffffff;
        box-sizing: border-box;
        border-radius:20px;
        border: 1px solid #999999;
      }
    }
  }
  .active {
    color: #f9591b;
  }
  .van-dialog {
    width: 274px;
    border-radius: 3px;
    .van-dialog__content {
      .van-dialog__message {
        font-size: 16px;
        padding: 30px 57px;
      }
    }
  }

}

.isiOSX.recharge-order-detail {
		// padding-top: 64px;
}
</style>
